export default function HomeThreeContact(){
    return(
        <>
            <section id="contact" className="contact-area pt-115 pb-90 pt-md-55 pb-md-30 pt-xs-55 pb-xs-30">
			<div className="container">
				<div className="row align-items-center">
					<div className="col-lg-6">
						<div className="section-title mb-60">
							<p className="mb-10">Get In Touch</p>
							<h2 className="sect-title text-heding3">Let's help you!</h2>
						</div>
						<form className="row contact-form mb-30" action="#">
							<div className="col-lg-6 col-md-6">
								<div className="input-box mb-20">
									<input type="text" placeholder="Full name**" />
								</div>
							</div>
							<div className="col-lg-6 col-md-6">
								<div className="input-box mail-input mb-20">
									<input type="text" placeholder="Email address**" />
								</div>
							</div>
							<div className="col-lg-12 mb-20">
								<div className="input-box sub-input">
									<select name="job" className="job-select">
										<option value="Subject">Subject</option>
										<option value="">It</option>
										<option value="">Development</option>
										<option value="">Ui/Ux</option>
									</select>
								</div>
							</div>
							<div className="col-12">
								<div className="input-box text-input mb-15">
									<textarea name="message" cols="30" rows="10"
										placeholder="Enter massge**"></textarea>
								</div>
							</div>

							<div className="col-12">
								<button className="form-btn form-btn2">Get Free Consultation</button>
							</div>
						</form>
					</div>
					<div className="col-lg-6">
						<div className="map-area2 mb-20 pl-40 pl-lg-0 pl-md-0 pl-xs-0">
							<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d14586.16663307975!2d90.3865062!3d23.941279099999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sbd!4v1641645837442!5m2!1sen!2sbd"
								></iframe>
						</div>
					</div>
				</div>
			</div>
		</section>
        </>
    )
}